import script from "./SMSModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SMSModal.vue?vue&type=script&lang=ts&setup=true"

import "./SMSModal.vue?vue&type=style&index=0&id=4fd15600&lang=scss"

const __exports__ = script;

export default __exports__